module.exports = __webpack_public_path__ + "media/images/patterns/header-profile-skin-1-0da692d184a28c297fcf214dabcc7549.png";